import { FunctionComponent, ReactNode } from "react";
import BlackWhiteStyles from "./styles/LinkBlackWhite.module.css";
import BlackStyles from "./styles/LinkBlack.module.css";
import WhiteBlackStyles from "./styles/LinkWhiteBlack.module.css";
import WhiteStyles from "./styles/LinkWhite.module.css";
import {
  LabelPairedChevronRightCaptionRegularIcon,
  LabelPairedChevronRightLgRegularIcon,
  LabelPairedChevronRightMdRegularIcon,
  LabelPairedChevronRightSmRegularIcon,
  LabelPairedChevronRightXlRegularIcon,
} from "@deriv/quill-icons/LabelPaired";

export type LinkType = {
  className?: string;
  label?: string;
  showChevron?: boolean;

  /** Variant props */
  size?: "caption" | "sm" | "md" | "lg" | "xl";
  state?: "default" | "disabled";

  /** Custom Props  */
  color?: "blackWhite" | "black" | "whiteBlack" | "white";
  icon?: ReactNode;
  href?: string;
  openNewTab?: boolean;
};

const linkStyles = {
  blackWhite: BlackWhiteStyles,
  black: BlackStyles,
  whiteBlack: WhiteBlackStyles,
  white: WhiteStyles,
} as const;

export const Link: FunctionComponent<LinkType> = ({
  className = "",
  label = "",
  showChevron = false,
  size = "caption",
  state = "default",
  color = "blackWhite",
  icon,
  href = "#",
  openNewTab = false,
}) => {
  const styles = linkStyles[color];
  const linkId = `quill-link-${color}-${size}-${state}`;

  const chevronIcon = {
    caption: LabelPairedChevronRightCaptionRegularIcon,
    sm: LabelPairedChevronRightSmRegularIcon,
    md: LabelPairedChevronRightMdRegularIcon,
    lg: LabelPairedChevronRightLgRegularIcon,
    xl: LabelPairedChevronRightXlRegularIcon,
  };

  const ChevronIcon = chevronIcon[size];

  return (
    <a
      href={href}
      target={openNewTab ? "_blank" : undefined}
      className={[
        styles.root,
        className,
        "quill-ui-next-component",
        state !== "disabled"
          ? "quill-ui-next-pointer"
          : "quill-ui-next-pointer-disabled",
      ].join(" ")}
      data-id={linkId}
      data-size={size}
      data-state={state}
      onClick={(e) => {
        if (state === "disabled") {
          e.preventDefault();
          e.stopPropagation();
          return;
        }
      }}
      tabIndex={state === "disabled" ? -1 : 0}
      aria-disabled={state === "disabled"}
    >
      {icon && <div className={styles.icon1}>{icon}</div>}
      <div className={styles.label}>{label}</div>
      {showChevron && (
        <div className={styles.iconChevron}>
          {ChevronIcon && <ChevronIcon />}
        </div>
      )}
    </a>
  );
};

Link.displayName = "Link";

export default Link;
